import useTable from '../../context/TableContext';

export default function ActionButton({ id, idTable, onClick }) {
    const { 
        tableActions,
    } = useTable();

    if (typeof tableActions[idTable].selectedRows == 'undefined' || tableActions[idTable].selectedRows.length < 1) return;

    return (
            <input id={id} class="action-button btn btn-primary position-fixed bottom-0 end-0 me-3 mb-5" type="button" value="Action" onClick={onClick} />
    );
}